package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.TextAlign
import kotlinx.coroutines.delay
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.jetbrains.compose.web.css.px

@Composable
fun UploadingTextAnimation() {
    var dotCount by remember { mutableStateOf(0) }

    // Update dot count every 300ms
    LaunchedEffect(Unit) {
        while (true) {
            delay(400)
            dotCount = (dotCount + 1) % 4 // 0, 1, 2, 3 dots
        }
    }

    FieldTitleTextNormalSimple(
        text = "Uploading" + ".".repeat(dotCount),
        fontSize = 20.px,
        textAlign = TextAlign.Center
    )
}
